import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import AdminLayout from 'components/admin/AdminLayout';
import AdminDashboard from 'pages/admin/AdminDashboard';
import SuperAdmin from 'pages/admin/SuperAdmin';
import AdminAffiliateManagement from 'pages/admin/AdminAffiliateManagement';
import AdminPayoutManagement from 'pages/admin/AdminPayoutManagement';
import AdminConversions from 'pages/admin/AdminConversions';
import AdminAnalytics from 'pages/admin/AdminAnalytics';
import AdminEmailTemplates from 'pages/admin/AdminEmailTemplates';
import AdminEmailTemplateDetail from 'pages/admin/AdminEmailTemplateDetail';
import SystemSettings from 'pages/admin/SystemSettings';

/**
 * Wraps all /admin/* routes with AdminLayout and renders the correct child.
 * Add this as a single Route in Root so that /admin/dashboard, /admin/settings, etc. work.
 */
const AdminRoutes: React.FC = () => {
  const { path } = useRouteMatch();

  return (
    <AdminLayout>
      <Switch>
        {/* Explicit paths so /admin/settings always wins; settings first to avoid any fallthrough */}
        <Route exact path="/admin/settings" component={SystemSettings} />
        <Route exact path={`${path}/dashboard`} component={AdminDashboard} />
        <Route exact path={`${path}/superadmin`} component={SuperAdmin} />
        <Route exact path={`${path}/affiliates`} component={AdminAffiliateManagement} />
        <Route exact path={`${path}/payouts`} component={AdminPayoutManagement} />
        <Route exact path={`${path}/conversions`} component={AdminConversions} />
        <Route exact path={`${path}/emails/:id`} component={AdminEmailTemplateDetail} />
        <Route exact path={`${path}/emails`} component={AdminEmailTemplates} />
        <Route exact path={`${path}/analytics`} component={AdminAnalytics} />
        <Route exact path={path} component={AdminDashboard} />
        <Route path={path} component={AdminDashboard} />
      </Switch>
    </AdminLayout>
  );
};

export default AdminRoutes;
